import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {AuthenticateModalProps} from '@Modals/authenticate-modal/authenticate-modal';
import {GA4EventName, GA4EventParamName, trackGA4CustomEvent} from '@Libraries/ga-events';

const DEFAULT_SIGNUP_SOURCE = 'default';

export const openAuthenticateModal = (props: AuthenticateModalProps): void => {
  trackGA4CustomEvent(GA4EventName.FUNNEL_SIGNUP_WALL_SHOWN, {[GA4EventParamName.SOURCE]: props.signupSource ?? DEFAULT_SIGNUP_SOURCE});
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AUTHENTICATE_MODAL,
      panelProps: props,
    })
  );
};
